import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { HeroBannerWrapper } from '../layouts/HeroBannerWrapper/HeroBannerWrapper';
import { ButtonTabs } from '../components/ButtonTabs/ButtonTabs';
import { PromoStripWrapper } from '../layouts/PromoStripWrapper/PromoStripWrapper';
import { StandardContentBlockWrapper } from '../layouts/StandardContentBlockWrapper/StandardContentBlockWrapper';
import { ButtonWithContentWrapper } from '../layouts/ButtonWithContentWrapper/ButtonWithContentWrapper';
import { BackToTop } from '../components/BackToTop/BackToTop';
import { useLocation } from 'react-router-dom';
import { ProductListing } from '../layouts/ProductListing/ProductListing';
import { BeyondTheLabel } from '../layouts/BeyondTheLabel/BeyondTheLabel';
import { useContentfulEntries, BrandUtil } from 'dw-us-ui';
import { Loader } from '../components/Loader/Loader';
import { Breadcrumb } from '../components/Breadcrumb/Breadcrumb';
import { BlogImageContent } from '../components/BlogImageContent/BlogImageContent';
import { MultipleBlogImageContent } from '../components/MultipleBlogImageContent/MultipleBlogImageContent';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { BeyondTheLabelMixed } from '../layouts/BeyondTheLabel/BeyondTheLabelMixed';

const SinglePageItem = () => {
  const location = useLocation();
  const { path } = useParams();

  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  let contentReturn = useContentfulEntries({
    contentType: 'hubPage',
    environment: 'master',
    additionalFilters: {
      'fields.slug': path,
      'fields.brand': brandTag.toUpperCase(),
    },
  });

  const [winePlanSubscription, setWinePlanSubscription] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    if (contentReturn) {
      setLoading(false);
    }
  }, [contentReturn]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    axios
      .get(`/api/user/subscriptions/wineplans/list`)
      .then(res => {
        if (res?.data.response.winePlanSubscriptions.length) {
          setWinePlanSubscription({
            ...winePlanSubscription,
            winePlanSubscription: res?.data.response?.winePlanSubscriptions,
          });
        }
      })
      .catch(err => {
        console.warn('wineplans list is experiencing an error:', err);
      });
  }, []);

  const getComponentName = items => {
    const { fields, sys } = items;
    const type = fields?.module || sys?.contentType?.sys?.id;
    switch (type) {
      case 'hero_banner':
      case 'imageBlock':
        return <HeroBannerWrapper bannerContent={fields?.blocks || fields} opacity={fields?.opacity} />;
      case 'button_with_content':
        return <ButtonWithContentWrapper fields={fields} />;

      case 'promo_strip':
        return <PromoStripWrapper fields={fields} />;

      case 'standard_content_block':
      case 'textBlockWithMobile':
        return <StandardContentBlockWrapper fields={fields} />;
      case 'product':
        return fields?.type === 'add_to_card' ? (
          <ProductListing fields={fields} winePlanSubscription={winePlanSubscription} />
        ) : fields?.itemCode.startsWith('M') ? (
          <BeyondTheLabelMixed itemCode={fields?.itemCode} brand={contentReturn?.brand} />
        ) : (
          <BeyondTheLabel fields={fields} brand={contentReturn?.brand} />
        );
      case 'html_block':
        return (
          <div className="row row-print">
            {fields.blocks.map(block => {
              return (
                <div
                  id="container_iframe"
                  className={block.fields.cssLayout}
                  dangerouslySetInnerHTML={{
                    __html: block.fields.htmlContent,
                  }}
                ></div>
              );
            })}
          </div>
        );
      case 'nav_tab':
        return <ButtonTabs navTab={fields?.blocks} />;
      case 'breadcrumb':
        return <Breadcrumb fields={fields} />;
      case 'blog_image_content':
        return <BlogImageContent fields={fields} />;
      case 'multiple_blog_image_content':
        return <MultipleBlogImageContent fields={fields} />;
      default: {
        return null;
      }
    }
  };
  return (
    <div className="vineyard-parent">
      {isLoading && <Loader />}
      {contentReturn && (
        <>
          <Helmet>
            {contentReturn?.seoTitle && <title>{contentReturn?.seoTitle}</title>}
            {contentReturn?.seoKeywords && <meta name="keywords" content={contentReturn?.seoKeywords} />}
            {contentReturn?.seoDescription && <meta name="description" content={contentReturn?.seoDescription} />}
          </Helmet>
          <HeroBannerWrapper
            bannerContent={contentReturn?.banner?.fields?.blocks}
            opacity={contentReturn?.banner?.fields?.opacity}
          />
        </>
      )}
      {contentReturn &&
        contentReturn?.section.length > 0 &&
        contentReturn?.section.map(items => {
          return getComponentName(items);
        })}
      <BackToTop />
    </div>
  );
};

export default SinglePageItem;
